var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement, useCallback, useEffect, useState } from "react";
import { getNews, getPages } from "../../apis/api";
import { News } from "./News";
import { useNavigate, useParams } from "react-router-dom";
import { toSlug } from "../../util/theme";
import { PageNotFound } from "../../components/PageNotFound";
export const NewsContainer = () => {
    const [noticias, setNoticias] = useState([]);
    const [noticia, setNoticia] = useState();
    const [pages, setPages] = useState([]);
    const { slug } = useParams();
    const navigate = useNavigate();
    const fetchPages = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield getPages();
        setPages(response);
    }), []);
    // Função para buscar as notícias
    const fetchNews = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield getNews();
        setNoticias(response);
    }), []);
    useEffect(() => {
        !!pages.length || fetchPages();
        !!noticias.length || fetchNews();
        const noticia = noticias.find((news) => news.slug === slug);
        setNoticia(noticia);
    }, [fetchPages, fetchNews, pages, noticias, setNoticia, noticia, slug]);
    const navegatePage = useCallback((page) => {
        navigate("/" + toSlug(page.Titulo));
    }, [navigate]);
    if (!noticia) {
        return createElement(PageNotFound);
    }
    else {
        return createElement(News, { noticia, pages, navegatePage });
    }
};
